import {
  Text,
  View,
  Image,
  useWindowDimensions,
  ViewStyle,
  TextStyle,
  ImageStyle,
} from 'react-native';
import React from 'react';
import {mergeDeepRight} from 'ramda';
import {corner_radius, spacing} from 'theme/Units';

type propTypes = Readonly<{
  imageUri: any;
  title: string;
  description: string;
}>;

export default function ActionCard(props: propTypes) {
  const {width: SCREEN_WIDTH} = useWindowDimensions();
  const {description, imageUri, title} = props;

  /**
   * responsive ness logic
   */
  let overrideStyles = structuredClone(baseStyles);
  if (SCREEN_WIDTH < 720) {
    overrideStyles.title.fontSize = 18;
    overrideStyles.image.width = 40;
    overrideStyles.image.height = 40;
    overrideStyles.card.padding = spacing['3'];
  }
  if (SCREEN_WIDTH < 640) {
    overrideStyles.title.fontSize = 16;
    overrideStyles.image.width = 32;
    overrideStyles.image.height = 32;
    overrideStyles.description.fontSize = 12;
    overrideStyles.card.padding = spacing['2'];
  }
  if (SCREEN_WIDTH < 480) {
    overrideStyles.title.fontSize = 14;
    overrideStyles.image.width = 24;
    overrideStyles.image.height = 24;
  }

  const styles: styleType = mergeDeepRight(baseStyles, overrideStyles) as any;

  return (
    <View style={styles.card}>
      <View style={styles.header}>
        <View style={styles.image}>
          <Image
            source={imageUri}
            style={styles.icon}
          />
        </View>
        <Text style={styles.title}>{title}</Text>
      </View>
      <Text style={styles.description}>{description}</Text>
    </View>
  );
}

type styleType = {
  card: ViewStyle;
  header: ViewStyle;
  image: ViewStyle;
  title: TextStyle;
  description: TextStyle;
  icon: ImageStyle;
};

const baseStyles: styleType = {
  card: {
    gap: spacing['2'],
    padding: spacing['4'],
    borderRadius: corner_radius['rounded-lg'],
    backgroundColor: 'white',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing['2'],
  },
  image: {
    boxShadow: '0px 0px 32px 6px rgba(0, 0, 0, 0.1)',
    justifyContent: 'center',
    alignItems: 'center',
    width: 48,
    height: 48,
  },
  icon: {
    width: '65%',
    height: '65%',
    resizeMode: 'contain',
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
  },
  description: {
    fontSize: 14,
    color: '#4A4E5E',
    fontWeight: '600',
  },
};
